export default __webpack_public_path__ + "static/media/interaction-arrow-next-white.259af8ac.svg";